import React, { useState, useCallback, useRef } from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

const Video = styled.video`
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;

  transform: translate(-50%, -50%);

  background: url(//demosthenes.info/assets/images/polina.jpg) no-repeat;
  background-size: cover;
  transition: 1s opacity;
`;

const ToggleVideoButton = styled.button`
  height: 100%;
  width: 100%;
`;
export default function BackgroundVideo({
  autoplay,
  controls,
  loop,
  muted,
  onClick,
  src,
}) {
  const videoEl = useRef(null);
  const [isPlaying, setIsPlaying] = useState(autoplay);

  const handleToggleVideo = useCallback(() => {
    setIsPlaying(!isPlaying);
    if (!isPlaying) {
      videoEl.current.play();
    } else {
      videoEl.current.pause();
    }
  }, [isPlaying]);

  /* eslint-disable-next-line jsx-a11y/media-has-caption */
  const videoElement = (
    <Video
      ref={videoEl}
      autoPlay={autoplay}
      controls={controls}
      loop={loop}
      muted={muted}
      onClick={onClick}
      playsinline
    >
      <source src={src} type="video/mp4" />
    </Video>
  );

  if (!controls) {
    return (
      <ToggleVideoButton onClick={handleToggleVideo}>
        {videoElement}
      </ToggleVideoButton>
    );
  }

  return videoElement;
}

BackgroundVideo.propTypes = {
  autoplay: PropTypes.bool,
  controls: PropTypes.bool,
  loop: PropTypes.bool,
  muted: PropTypes.bool,
  onClick: PropTypes.func,
  src: PropTypes.string.isRequired,
};

BackgroundVideo.defaultProps = {
  autoplay: false,
  controls: true,
  loop: false,
};
